import { GridActionsCellItem } from '@mui/x-data-grid';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import { format, parseISO } from 'date-fns';
// project import
import CamelCaseToWords from 'utils/helpers/CamelCaseToWords';
import { ColumnTypes } from 'constants/ColumnTypes';
import { FormFieldCustomComponentTypes } from 'constants/FormFieldCustomComponentTypes';
import FieldNameToOptionSwitch from 'utils/helpers/FieldNameToOptionSwitch';
import { TableActionsTypes } from 'constants/TableActionsTypes';
// eslint-disable-next-line no-unused-vars
import numberFormat from 'utils/helpers/NumberFormat';
import renderCellExpand from 'utils/helpers/renderCellExpand';

function CustomTableColumnConfigBuilder(
    config,
    availableListActionsConfig,
    handleOnClickPostAction,
    entity,
) {
    let columns = [
        // {
        //     field: 'id',
        //     headerName: 'Id',
        //     flex: 1,
        //     sortable: true,
        //     filterable: true,
        //     maxWidth: 100,
        // },
    ];

    config[0]?.config().forEach(column => {
        if (!column?.list) {
            return;
        }
        switch (column?.componentType) {
            case FormFieldCustomComponentTypes.CustomAutoComplete:
                columns.push(
                    Object.assign(
                        {
                            field: column?.attribute,
                            headerName: CamelCaseToWords(
                                column?.title || column?.attribute,
                            ),
                            type: ColumnTypes.Autocomplete,
                            flex: 1,
                            sortable: true,
                            filterable: true,
                            componentProps: {
                                search: {
                                    asyncProps: {
                                        path:
                                            column.list.path ||
                                            column?.async?.url,
                                        searchFieldName:
                                            column.list.searchFieldName ||
                                            (column?.async?.url.includes(
                                                '/search',
                                            )
                                                ? 'queryValue'
                                                : `filter.${column?.optionConfig?.label}`),
                                        searchOptionFieldValue:
                                            column.list
                                                .searchOptionFieldValue ||
                                            column?.optionConfig?.value,
                                        filterFieldName:
                                            column.list.filterFieldName ||
                                            column?.attribute,
                                    },
                                    getOptionLabel: option => {
                                        return typeof option === 'string'
                                            ? option
                                            : option[
                                                  column.list
                                                      .displayFieldName ||
                                                      column?.optionConfig
                                                          ?.label
                                              ];
                                    },
                                },
                            },
                            renderCell: renderCellExpand,
                        },
                        typeof column.list !== 'boolean' ? column.list : {},
                    ),
                );
                break;
            case FormFieldCustomComponentTypes.CustomStandardSelect:
                columns.push(
                    Object.assign(
                        {
                            field: column?.attribute,
                            headerName: CamelCaseToWords(
                                column?.title || column?.attribute,
                            ),
                            type: ColumnTypes.Select,
                            flex: 1,
                            sortable: true,
                            filterable: true,
                            componentProps: {
                                search: {
                                    options: column.list.options,
                                    optionValue: column.list.optionValue,
                                    getOptionLabel: option => {
                                        return typeof option === 'string'
                                            ? option
                                            : option[column.list.optionLabel];
                                    },
                                },
                            },
                        },
                        typeof column.list !== 'boolean' ? column.list : {},
                    ),
                );
                break;

            case FormFieldCustomComponentTypes.Switch:
                columns.push(
                    Object.assign(
                        {
                            field: column?.attribute,
                            headerName: CamelCaseToWords(
                                column?.title || column?.attribute,
                            ),
                            type: ColumnTypes.Autocomplete,
                            flex: 1,
                            sortable: true,
                            filterable: true,
                            componentProps: {
                                search: {
                                    options: FieldNameToOptionSwitch(
                                        column?.attribute,
                                    ),
                                    asyncProps: {
                                        searchFieldName: `filter[${column?.attribute}]`,
                                        searchOptionFieldValue: 'value',
                                        filterFieldName: column?.attribute,
                                    },
                                    getOptionLabel: option => option.title,
                                    isOptionEqualToValue: (option, value) =>
                                        option.value === value.value,
                                },
                            },
                            renderCell: params =>
                                params.value ? (
                                    <DoneAllIcon color="info" />
                                ) : (
                                    <RemoveDoneIcon color="warning" />
                                ),
                        },
                        typeof column.list !== 'boolean' ? column.list : {},
                    ),
                );
                break;
            case FormFieldCustomComponentTypes.CustomNumericField:
                columns.push(
                    Object.assign(
                        {
                            field: column?.attribute,
                            headerName: CamelCaseToWords(
                                column?.title || column?.attribute,
                            ),
                            flex: 1,
                            sortable: true,
                            filterable: true,
                            valueGetter: params =>
                                params?.value &&
                                Number(params?.value).numberFormat(
                                    column?.decimalScale || 0,
                                    Infinity,
                                    ' ',
                                    '.',
                                ),
                        },
                        typeof column.list !== 'boolean' ? column.list : {},
                    ),
                );
                break;
            case FormFieldCustomComponentTypes.CustomDateTimePicker:
                columns.push(
                    Object.assign(
                        {
                            field: column?.attribute,
                            headerName: CamelCaseToWords(
                                column?.title || column?.attribute,
                            ),
                            flex: 1,
                            sortable: true,
                            filterable: true,
                            valueGetter: params =>
                                params?.value
                                    ? format(
                                          parseISO(params?.value),
                                          'dd-MM-yyyy HH:mm:ss',
                                      )
                                    : '',
                        },
                        typeof column.list !== 'boolean' ? column.list : {},
                    ),
                );
                break;

            default:
                columns.push(
                    Object.assign(
                        {
                            field: column?.attribute,
                            headerName: CamelCaseToWords(
                                column?.title || column?.attribute,
                            ),
                            flex: 1,
                            sortable: true,
                            filterable: true,
                            renderCell: renderCellExpand,
                        },
                        typeof column.list !== 'boolean' ? column.list : {},
                    ),
                );
                break;
        }
    });

    entity?.ModelFeatureAttribute[TableActionsTypes.Deactivate] &&
        columns.push({
            field: 'inactive',
            headerName: 'Inactive',
            type: ColumnTypes.Autocomplete,
            flex: 1,
            sortable: true,
            filterable: true,

            componentProps: {
                search: {
                    options: FieldNameToOptionSwitch('inactive'),
                    asyncProps: {
                        searchFieldName: `filter.inactive`,
                        searchOptionFieldValue: 'value',
                        filterFieldName: 'inactive',
                    },
                    getOptionLabel: option => option.title,
                    isOptionEqualToValue: (option, value) =>
                        option.value === value.value,
                },
            },
            renderCell: params =>
                params.value ? (
                    <DoneAllIcon color="info" />
                ) : (
                    <RemoveDoneIcon color="warning" />
                ),
        });

    const notShowInMenu = [
        'edit',
        'delete',
        'delete_with_action',
        'custom_edit',
        'manage',
        'manage_laptop',
        'manage_tablet',
        'impersonate',
        'toggle_enabled',
        'change_status',
    ];
    const notShowInMenuItemLength = availableListActionsConfig.reduce(
        (accumulator, currentValue) => {
            if (notShowInMenu.includes(currentValue[0])) {
                return ++accumulator;
            }
            return accumulator;
        },
        0,
    );
    availableListActionsConfig.length > 0 &&
        columns.push({
            type: ColumnTypes.Actions,
            field: 'actions',
            headerName: 'Actions',
            minWidth: 50 * notShowInMenuItemLength,
            hideable: false,
            disableReorder: true,
            getActions: params => {
                return availableListActionsConfig.map(
                    ([type, Action], index) => {
                        return (
                            <Action
                                key={`action-${index}`}
                                showInMenu={
                                    (type === 'deactivate' &&
                                        !params?.row?.inactive) ||
                                    notShowInMenu.includes(type)
                                        ? false
                                        : true
                                }
                                params={params}
                                component={GridActionsCellItem}
                                onClick={action =>
                                    handleOnClickPostAction(action)
                                }
                            />
                        );
                    },
                );
            },
        });

    return columns;
}
export default CustomTableColumnConfigBuilder;
